/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateNewConsultationsRequest
 */
export interface CreateNewConsultationsRequest {
    /**
     * UUID of the institute
     * @type {string}
     * @memberof CreateNewConsultationsRequest
     */
    instituteWithRoleId?: string;
    /**
     * UUID of the health pro
     * @type {string}
     * @memberof CreateNewConsultationsRequest
     */
    healthProId?: string;
}

/**
 * Check if a given object implements the CreateNewConsultationsRequest interface.
 */
export function instanceOfCreateNewConsultationsRequest(value: object): value is CreateNewConsultationsRequest {
    return true;
}

export function CreateNewConsultationsRequestFromJSON(json: any): CreateNewConsultationsRequest {
    return CreateNewConsultationsRequestFromJSONTyped(json, false);
}

export function CreateNewConsultationsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNewConsultationsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteWithRoleId': json['instituteWithRoleId'] == null ? undefined : json['instituteWithRoleId'],
        'healthProId': json['healthProId'] == null ? undefined : json['healthProId'],
    };
}

export function CreateNewConsultationsRequestToJSON(json: any): CreateNewConsultationsRequest {
    return CreateNewConsultationsRequestToJSONTyped(json, false);
}

export function CreateNewConsultationsRequestToJSONTyped(value?: CreateNewConsultationsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteWithRoleId': value['instituteWithRoleId'],
        'healthProId': value['healthProId'],
    };
}

